import React from 'react'
import { Route, Switch } from 'react-router-dom'
import EventRegister from './EventRegister'
import Registration from './Registration'
import RegistrationEdit from './RegistrationEdit'
import RegistrationPayment from './RegistrationPayment'
import RegistrationPreview from './RegistrationPreview'
import Error404 from '../Error/404'

const EventRegistration = () => (
  <Switch>
    <Route exact path="/events/:eventSlug/register" component={EventRegister} />
    <Route exact path="/events/:eventSlug/private" render={props => <EventRegister {...props} showHiddenTypes />} />
    <Route exact path="/reg/:id/edit" component={RegistrationEdit} />
    <Route exact path="/reg/:id/preview" component={RegistrationPreview} />
    <Route exact path="/reg/:id/pay" component={RegistrationPayment} />
    <Route exact path="/reg/:id" component={Registration} />
    <Route exact path="/:eventSlug/register" component={EventRegister} />
    <Route exact path="/:eventSlug/private" render={props => <EventRegister {...props} showHiddenTypes />} />
    <Route exact path="*" component={Error404} />
  </Switch>
)

export default EventRegistration



// WEBPACK FOOTER //
// ./src/App/pages/EventRegistration/EventRegistration.js